import { createGenericFiltersContext } from '@vlabs/monokit/shared/lib';

export interface SourceStreamsFilters {
  group_id?: string;
  page?: number;
  page_size?: number;
  names?: string[];
  statuses?: number[];
  reference?: string;
  order?: 'asc' | 'desc';
}

const [
  useSourceFilters,
  SourceFiltersProvider,
] = createGenericFiltersContext<SourceStreamsFilters>({
  displayName: 'SourceFilters',
});

export {
  useSourceFilters,
  SourceFiltersProvider,
};
